import { Box, Button, Modal, Typography } from "@mui/material";
import { WarningIcon } from "../../assests/images";

type ComponentProps = {
  isModalOpen: boolean;
  handleModalClose: any;
  handleSkipClick: any;
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 556,
  borderRadius: "10px",
  bgcolor: "background.paper",
  padding: "76px 74px 70px",
  textAlign: "center",
  "@media (max-width:599px)": {
    width: "calc(100% - 30px)",
    padding: "30px",
  },
};

export const SkipVideoMessageModal = (props: ComponentProps) => {
  const { handleModalClose, handleSkipClick, isModalOpen } = props;

  return (
    <>
      <Modal
        open={isModalOpen}
        onClose={handleModalClose}
        className="reset-modal"
      >
        <Box sx={style}>
          <img src={WarningIcon} alt="Done" className="reset-img" />
          <Typography variant="h2">Information</Typography>
          <Typography variant="body1">
            We insist that you watch the entire video before proceeding with the
            agreement. You can skip the video by clicking "Skip Video" button.
          </Typography>
          <div className="warning-modal-btn-group">
            <Button variant="contained" onClick={handleSkipClick}>
              Skip Video
            </Button>
            <Button variant="outlined" onClick={handleModalClose}>
              Close
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  );
};
